var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4145 12.6415V16.2929C18.4145 19.3718 15.5427 21.8685 12 21.8685C8.45722 21.8685 5.58551 19.3718 5.58551 16.2929V12.6415C5.58551 15.7205 8.45722 17.9211 12 17.9211C15.5427 17.9211 18.4145 15.7205 18.4145 12.6415Z",
    fill: "#005057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.4145 7.70728V12.6415C18.4145 15.7204 15.5427 17.9211 12 17.9211C8.45722 17.9211 5.58551 15.7204 5.58551 12.6415V7.70728C5.58551 8.6053 5.83222 9.43425 6.26643 10.1448C7.32235 11.8816 9.49341 12.9869 12 12.9869C14.5066 12.9869 16.6776 11.8816 17.7335 10.1448C18.1677 9.43425 18.4145 8.6053 18.4145 7.70728Z",
    fill: "#005057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4145 7.70725C18.4145 8.60528 18.1677 9.43422 17.7335 10.1447C16.6776 11.8816 14.5066 12.9869 12 12.9869C9.49341 12.9869 7.32235 11.8816 6.26643 10.1447C5.83222 9.43422 5.58551 8.60528 5.58551 7.70725C5.58551 4.6283 8.45722 2.13159 12 2.13159C13.7763 2.13159 15.375 2.7533 16.5395 3.75988C17.6941 4.77633 18.4145 6.16778 18.4145 7.70725Z",
    fill: "#005057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorStack);
export default __webpack_public_path__ + "static/media/color-stack.f0c19ad3.svg";
export { ForwardRef as ReactComponent };